export default "__VITE_ASSET__C6NyhZ2D__"